import { integrationMapping } from '@/helpers/integrationMapping';
import type { EHRProvider } from '@heidi/schema/ml-scribe';
import type { StaticImageData } from 'next/image';

/**
 * Public URL of the bundled logo for an EHR, or `undefined` when it has none.
 *
 * `integrationMapping` icons are typed `string`, but Next hands static `.svg`
 * imports over as `StaticImageData` at runtime. A preload `href` needs the URL
 * itself, so this unwraps it.
 */
export const getEhrLogoUrl = (provider?: EHRProvider | null): string | undefined => {
  const icon = (provider ? integrationMapping[provider]?.icon : undefined) as
    | string
    | StaticImageData
    | undefined;
  if (!icon) return undefined;
  return typeof icon === 'string' ? icon : icon.src;
};
